<template>
	<div class="knowledge-management">
		<div class="module-item-style knowledge-management-filter">
			<div>
				<div class="wl-btn add" @click="addMethods">添加问题</div>
				<el-input placeholder="请输入搜索内容" clearable v-model="searchText" class="input-search-problem">
					<el-button slot="append" icon="el-icon-search" @click="filterLsit"></el-button>
				</el-input>
			</div>
			<div class="import-wrap">
				<div class="download">下载<a href="/Public/download/weiliao-greetLibrary-template.xls" download>《寒暄库数据导入模板》</a></div>
				<div class="wl-btn-empty add" @click="importData">
					导入数据
					<input type="file" ref="inportInput" hidden @change="importInputChange">
				</div>
			</div>
			
			
		</div>
		<div class="module-item-style table-data table-box">
			<el-table ref="multipleTable" 
			:data="tableData" stripe 
			:header-cell-style="{background:'#f2f2f2'}" 
			style="border: 1px solid #ebeef5;"
			 @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="问题">
					<template slot-scope="scope">
						<span>{{scope.row.title}}</span>
					</template>
				</el-table-column>
				<el-table-column label="回答">
					<template slot-scope="scope">
						<span class="wl-elliphis2" :title="scope.row.answer">{{scope.row.answer || '[图片回复]'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作时间">
					<template slot-scope="scope">
						<span class="">{{scope.row.updateTime}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<button class="tb-btn tb-btn-edit" @click="greetOpenClose(scope.row)">{{scope.row.isActive==1?'停用':'启用'}}</button>
						<button class="tb-btn tb-btn-edit" @click="editMethods(scope.row)">编辑</button>
						<button class="tb-btn tb-btn-del" @click="delProblem('delSingle',scope.row.id)">删除</button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top: 20px;padding-left: 14px;" v-if="tableData.length > 0">
				<el-checkbox v-model="checkAll" @change="toggleSelection()"></el-checkbox>
				<span class="wl-btn-del ml20" @click="delProblem('delAll',SelectionData)">批量删除</span>
			</div>
			<!--    分页-->
			
			<pagenations :total="total" :size="pageSize" @pageHandler="pageOperate"></pagenations>
		</div>
	</div>
</template>

<script>
	import pagenations from '@/components/pagenations/pagenations'

	export default {
		name: 'knowledge-management',
		components: {
			pagenations
		},
		data() {
			return {
				currentPage: 1,
				pageSize: 10,
				searchText: '',
				tableData: [],
				total: 0,
				checkAll: '',
				SelectionData: [],
			}
		},
		created() {
			this.getGreetingLibList()
		},
		mounted() {
			eventBus.$on("reloadProblemTable", () => {
				this.getGreetingLibList()
			})
		},
		methods: {
			handleSelectionChange(val) {
				if (val.length > 0) {
					this.checkAll = true
				} else {
					this.checkAll = false
				}
				this.SelectionData = val
			},
			toggleSelection() {
				if (this.checkAll) {
					this.$refs.multipleTable.toggleAllSelection();
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			/**
			 *  分页操作
			 * @param val
			 */
			pageOperate(val) {
				if (val.type == 'currentChange') {
					this.currentPage = val.val
				} else if (val.type == "sizeChange") {
					this.pageSize = val.val
				}
				this.getGreetingLibList()
			},
			getGreetingLibList() {
				this.$http.getGreetingLibListAPI({
					searchText: this.searchText,
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}).then(res => {
					if (res.status == 1) {
						this.tableData = res.data.list
						this.total = res.data.total
					}
				})
			},
			addMethods(){
				eventBus.$emit('addProblem')
			},
			editMethods(row){
				eventBus.$emit('editProblem',row)
			},
			delProblem(type,id) {
				let idArr = []
				if (type == "delSingle") {
					idArr.push(id)
				} else if (type == "delAll") {
					if (id.length == 0) {
						this.$message({
							message: '请选择要删除的数据',
							type: 'error'
						})
						return false
					}
					id.forEach((item, index) => {
						idArr.push(item.id)
					})
				}
				this.$confirm('将要进行删除操作, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delGreetingAPI(idArr).then(res => {
						if (res.status == 1) {
							this.getGreetingLibList()
							this.$message({
								message: res.msg,
								type: 'success',
							})
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							})
						}
					})
				}).catch(() => {})
				
			},
			greetOpenClose(row) {
				let postData = {
					id:row.id,
					isActive:row.isActive==1?0:1
				}
				this.$http.greetOpenCloseAPI(postData).then(res => {
					if (res.status == 1) {
						this.getGreetingLibList()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			filterLsit() {
				this.getGreetingLibList()
			},
			/**
			 * 导入数据
			 */
			importData(){
			  this.$refs.inportInput.click()
			},
			importInputChange(e){
			  let file = e.target.files[0]
			  let size = file.size
			  let name = file.name
			  var suffix = name.substr(name.lastIndexOf("."));
			  console.log(suffix)
			  console.log(".xls" != suffix && ".xlsx" != suffix)
			  if(".xls" != suffix && ".xlsx" != suffix ){
			    this.$message({
			      showClose: true,
			      message: '文件格式不正确，请选择Excel格式的文件导入',
			      type: 'error',
			      duration: 3 * 1000
			    })
			    return false;
			  }
			  let formdata = new FormData()
			  formdata.set('file', file)
			  this.$http.greetingLibImportAPI(formdata).then( res => {
			    if(res.status == 1){
				  this.searchText = ""
				  this.currentPage = 1
				  this.pageSize = 10
			      this.getGreetingLibList()
			      this.$message({
			        message: res.msg,
			        type: 'success',
			      })
			    }else {
			      this.$message({
			        message: res.msg,
			        type: 'error',
			      })
			    }
			  })
			
			},
		}
	}
</script>

<style lang="scss">
	.knowledge-management {
		.knowledge-management-filter {
			display: flex;
			justify-content: space-between;
			.input-search-problem {
				width: 300px;
				margin-left: 0px;
			}
			.import-wrap{
				display: flex;
				align-items: center;
				.download {
					font-size: 12px;
					margin-right: 5px;
					a {
						color: $mainColor;
						margin-left: 3px;
					}
				}
			}
		}

		.select-type {
			width: 300px;
		}

		.wl-btn-del {
			margin-left: 15px;
		}
		.wl-btn.add,.wl-btn-empty.add{
			// margin-right: 20px;
		}
		.table-data {
			position: relative;
		}
	}
</style>
